import React from 'react';
import SVGIcon, { BASE_ICONS } from 'src/components/svg';
import { lang, scssVariables as variables } from 'src/helpers';

export default class OriginalMessage extends React.PureComponent {
  render() {
    let { originalMessage, onClose, show } = this.props;
    return (
      <div className={'mc-send-box-msg-edit ' + (!show ? 'mc-hide' : '')}>
        <div className={'mc-mt10'}>
          <SVGIcon iconname={BASE_ICONS.EDIT} fill={variables['colors-mc-primary']} />
        </div>
        <div className={'mc-flex-5-col mc-grow'}>
          <div className={'mc-primary-520'}>{lang.t('Edit Message')}</div>
          {originalMessage?.text}
        </div>
        <button type={'button'} className={'mc-no-style-btn'} onClick={onClose}>
          <SVGIcon iconname={BASE_ICONS.CLOSE} width={20} />
        </button>
      </div>
    );
  }
}
